import styled from "styled-components";

export const StyledLoadingMessage = styled.div`
    margin-bottom: 1rem;
    display: flex;
    justify-content: center;
`;

export const StyledWrapper = styled.div`
    height: 100vh;
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    align-items: center;
    justify-content: center;
`;
